import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonDirectives } from '@app/shared/directives/common-directives';

@Component({
  selector: 'app-pagination',
  imports: [CommonDirectives],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnChanges {
  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Output() pageChange = new EventEmitter<number>();

  pages: number[] = [];

  ngOnChanges() {
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  onPageChange(event: Event) {
    const selectedPage = +(event.target as HTMLSelectElement).value;
    if (selectedPage !== this.currentPage) {
      this.pageChange.emit(selectedPage);
    }
  }
}
